import service from '@/services/modules/school/school-detail/manager';
import * as types from './types';

export default {
  state: {
    managerList: [],
    newManagerList: [],
    manager: null,
    schoolName: '',
  },
  getters: {
    [types.MANAGER_LIST]: state => state.managerList,
    [types.NEW_MANAGER_LIST]: state => state.newManagerList,
    [types.MANAGER]: state => state.manager,
    [types.SCHOOL_NAME]: state => state.schoolName,
  },
  mutations: {
    [types.MANAGER_LIST]: (state, payload) => {
      state.managerList = payload.managerList;
    },
    [types.NEW_MANAGER_LIST]: (state, payload) => {
      state.newManagerList = payload.managerList;
    },
    [types.MANAGER]: (state, payload) => {
      state.manager = payload.manager;
    },
    [types.TOGGLE_FREEZE_MANAGER]: (state) => {
      state.manager.is_freeze = state.manager.is_freeze ? 0 : 1;
    },
    [types.DELETE_MANAGER]: (state) => {
      const index = state
        .managerList
        .findIndex(manager => manager.id === state.manager.id);
      if (index !== -1) {
        state.managerList.splice(index, 1);
      }
    },
    [types.SCHOOL_NAME]: (state, payload) => {
      state.schoolName = payload.schoolName;
    },
  },
  actions: {
    [types.MANAGER_LIST]: ({ commit }, payload) => {
      service
        .fetchManagerList(payload.schoolId)
        .then((data) => {
          commit(types.MANAGER_LIST, {
            managerList: data,
          });
        }, () => { });
    },
    [types.BATCH_CREATE_MANAGER]: ({ state, commit }, payload) => {
      service
        .batchCreateManager(payload.managerList)
        .then((data) => {
          commit(types.NEW_MANAGER_LIST, {
            managerList: data.manager_list,
          });
          commit(types.MANAGER_LIST, {
            managerList: [
              ...data.manager_list,
              ...state.managerList,
            ],
          });
        }, () => { });
    },
    [types.TOGGLE_FREEZE_MANAGER]: ({ state, commit }, payload) => {
      service
        .toggleFreezeManager(state.manager, payload.schoolId, payload.password)
        .then(() => {
          commit(types.TOGGLE_FREEZE_MANAGER);
        }, () => { });
    },
    [types.DELETE_MANAGER]: ({ state, commit }, payload) => service
      .deleteManager(state.manager, payload.schoolId, payload.password),
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/school/school-detail/manager/index.js